/* eslint-disable no-undef */
import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import { StyledModal, CustomTitle } from "../../AttendeesModal/styles";
import { Border } from "../../Journeys/styles";
import { CommonButtonPopup } from "../../ReportsV2/styles";
import { t } from "i18next";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Waiting from "../../Waiting";
import { AddUpdateUserWellbeingPillars, GetWellbeingPillars } from "../../../redux/constants/apiConstants";
import { CheckBoxContainer } from "../../../containers/Login/style";
import SkeletonLoder from "../../common/skeletonLoder";
import { QuestionsWrapper } from "./style";
import { fetchApi } from "../../../utils/methods";
import { NoData } from "../../SocialFeedsV2/styles";
import { toast } from "react-toastify";

const WellnessPillarModal = ({ showModal, onHide, /*history, fname,onClick*/ }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selectedWellbeingPillars, setSelectedWellbeingPillars] = useState([]);
  const [wellbeingPillars, setWellbeingPillars] = useState([]);


  useEffect(()=>{
    let lang = localStorage.getItem("lang") || "en";
    const langCode = lang === 'en' ? 1 : lang === 'es' ? 2 : lang === 'fr' ? 3 : lang === 'pt' ? 4: 1;
    getAllWellbeingPillars(langCode);
  },[])

  const getAllWellbeingPillars = async (language) => {
    setIsLoading(true);
    try {
      const res = await fetchApi(GetWellbeingPillars + "/" + language, "GET");

      if (res.status === "success") {
        setWellbeingPillars(res.data);
        setIsLoading(false);
      } else {
        toast.error(t(res.data.message || "Something went wrong"));
        setIsLoading(false);

      }
    } catch (error) {
      window.console.error(error);
      setIsLoading(false);
    }
  };

  const SelectGoal = (id) => {
    setSelectedWellbeingPillars((prevGoals) => {
      const alreadySelected = prevGoals.includes(id);
  
      if (alreadySelected) {
        // Remove if already selected
        return prevGoals.filter((goalId) => goalId !== id);
      } else if (prevGoals.length < 3) {
        // Add only if less than 3 are selected
        return [...prevGoals, id];
      } else {
        // Do nothing if 3 already selected
        return prevGoals;
      }
    });
  };

  const saveWellbeingPillars = async () => {
    setLoading(true);
    const payload = {
      wellbeing_pillars:selectedWellbeingPillars
    };

    try {
      const res = await fetchApi(AddUpdateUserWellbeingPillars, "POST", payload);
      if (res.status === "success") {
        setLoading(false);
        onHide()
      } else {
        toast.error(t(res?.data?.message));
        setLoading(false);
      }
    } catch (error) {
      window.console.error(error);
      setLoading(false);
    }
  };

  return (
    <>
      {loading && <Waiting/>}
    
      <StyledModal
        $width={"600px"}
        $height={"551 !important"}
        show={showModal}
        // onHide={onHide}
      >
        {/* Header */}
        <Modal.Header style={{ background: "#D3DEF2", border: "none" }}>
          <CustomTitle>
            <div>
              <span>{t('Wellness pillar onboarding quiz')}</span>
              {/* <span className="closeImage">
                <div onClick={onHide}>{AdminCloseIcon()}</div>
              </span> */}
            </div>
            <div className="sub-title">Select any 3 pillars you would like to focus on?</div>
          </CustomTitle>
        </Modal.Header>
   
        <Border
          style={{
            width: "146px",
            background: "#92A4DA",
            margin: "0px 0px 16px 0px",
            height:'5px'
          }}
        />
   
        <Modal.Body style={{ overflowY: "auto", maxHeight: "420px", padding: "0px 16px" }}>
          {isLoading ? (
            <>
              {Array.from({ length: 4 }).map((_, index) => (
                <QuestionsWrapper key={index}>
                  <div className="answer-box">
                    <SkeletonLoder width={"250px"} height={"50px"} />
                  </div>
                </QuestionsWrapper>
              ))}
            </>
          ) : wellbeingPillars.length > 0 ? (
            <>
   
              {wellbeingPillars?.map((pillar, index) => (
                <QuestionsWrapper key={index}>
                  <div className="answer-box" onClick={()=>SelectGoal(pillar.id)}>
                    <div className="attendeeInfo">
                      <span className="title">{pillar?.pillar_title}</span>
                      <div className='desc' title={pillar?.description}>{pillar?.description}</div>
                    </div>
                    <CheckBoxContainer selected={selectedWellbeingPillars.includes(pillar.id) ? true : false} >
                      <div className="selection" >{selectedWellbeingPillars.includes(pillar.id)? selectedWellbeingPillars.indexOf(pillar.id) + 1 : null}</div>
                    </CheckBoxContainer>
                  </div>
                </QuestionsWrapper>
              ))}
   
            </>
          ) : (
            <NoData>{t("No Data Found")}</NoData>
          )}
        </Modal.Body>
   
        {/* Footer */}
        <Modal.Footer
          style={{
            borderTop: "none",
            display: "flex",
            gap: "12px",
            width: "100%",
          }}
        >
          <div style={{ display: "flex", gap: "12px", marginTop: "20px",width:'100%', justifyContent:'center' }}>
            <CommonButtonPopup
              height="40px"
              width="200px"
              onClick={saveWellbeingPillars}
              disabled={!selectedWellbeingPillars.length}
            >
              {t("Next")}
            </CommonButtonPopup>
    
          </div>
        </Modal.Footer>  
      </StyledModal>
    </>
  );
};

WellnessPillarModal.propTypes = {
  showModal: PropTypes.bool.isRequired,
  onHide: PropTypes.func,
  challengeId:PropTypes.number,
  fname:PropTypes.string,
  history:PropTypes.object,
  onClick:PropTypes.func
};

export default withRouter(connect(null, null)(withTranslation()(WellnessPillarModal)));
